import { StoryblokComponent } from '@storyblok/react'
import { useTranslation } from 'next-i18next'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { visuallyHidden } from 'ui/src/utils/visuallyHidden.css'
import { usePriceCalculatorNonTierCoverageInfo } from '../priceCalculatorAtoms'

export function NonCoverageInfoDialogContent() {
  const { t } = useTranslation('purchase-form')
  const coverageInfo = usePriceCalculatorNonTierCoverageInfo()

  return (
    <LargeDialog.Content>
      <LargeDialog.Header className={visuallyHidden}>{t('COVERAGE_DIALOG_TRIGGER_HEADER')}</LargeDialog.Header>
      {coverageInfo.map((blok) => (
        <StoryblokComponent key={blok._uid} blok={blok} nested={true} />
      ))}
    </LargeDialog.Content>
  )
}
